const LaunchpadEmtyCard = () => {
  return (
    <div className="colum w-4">
      <div className="guide-open">
        <div className="line-open">
          <img src="./images/line-open.png" alt="" />
        </div>
        <div className="box-img">
          <img src="./images/empty-project1.png" alt="" />
        </div>
        <div className="avatar-open">
          <div className="avt-img">
            <img src="./images/ava-empty.png" alt="" />
          </div>
        </div>

        <div className="info-open-box">
          <div className="title">TBA</div>
          <div className="item">
            <div className="txt-l">Network</div>
            <div className="txt-r">TBA</div>
          </div>
          <div className="item">
            <div className="txt-l">Symbol</div>
            <div className="txt-r">TBA</div>
          </div>
          <div className="item">
            <div className="txt-l">Price</div>
            <div className="txt-r">TBA</div>
          </div>
          <div className="item">
            <div className="txt-l">Total Raise </div>
            <div className="txt-r">TBA</div>
          </div>
          <div className="item">
            <div className="txt-l">IDO Date</div>
            <div className="txt-r">TBA</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LaunchpadEmtyCard;
